import { HeroImage } from "../../../assets/Products";

export default function SectionOne()
{
    return(
        <section
            className="py-5 bg-cover bg-center h-80 md:h-96 flex items-center"
            style={{ backgroundImage: `url(${HeroImage})` }}
        >
        <div className="flex justify-center text-center font-bold md:max-w-sm xl:max-w-md">
            <p className="text-2xl xl:text-3xl pl-5">Your Go-To Store for <span className="text-red-900 font-bold">Constant Deals </span>on Laptops, Desktops, & Accessories!</p>
        </div>
        </section>

    );
}